import { Button, Modal } from '@onsaui'
import { IconArrowRightSm } from '@onsaui/icons'
import cx from 'clsx'
import { useState } from 'react'

import PriceBadge from '@/modules/billing/components/PriceBadge/PriceBadge'

// React.FC<React.SVGProps<SVGSVGElement>>

const CreateTaskCard: React.FC<{
  illustrationSrc: string
  title: React.ReactNode
  description: React.ReactNode
  buttonLabel: string
  modalContent?: React.ReactNode
  className?: string
  onButtonClick?: () => void
  price?: number
  freeIcp?: boolean
  beta?: boolean
  autoOpen?: boolean
}> = ({
  illustrationSrc,
  title,
  description,
  price,
  freeIcp,
  beta,
  buttonLabel,
  modalContent,
  onButtonClick,
  autoOpen,
  className,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(autoOpen)

  const handleCardClick = () => {
    onButtonClick?.()
    setIsModalOpen(true)
  }

  return (
    <>
      {modalContent ? (
        <Modal
          className="flex max-w-md flex-col items-center"
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          {modalContent}
        </Modal>
      ) : null}
      <div
        className={cx(
          'relative flex max-w-3xl cursor-pointer flex-row items-center overflow-hidden rounded-[20px] border border-disabled bg-level1 transition-colors hover:border-primary',
          className,
        )}
        onClick={handleCardClick}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleCardClick()
          }
        }}
      >
        {price && !freeIcp && <PriceBadge price={price} className="absolute right-3 top-2" />}

        {/* {freeIcp && (
        <div
          className={cx('absolute right-3 top-2 rounded-xl bg-black px-3 py-2 text-sm text-white')}
        >
          <span className="font-bold">Free</span>
        </div>
      )} */}

        {/* {beta && (
        <div className="absolute left-2 top-2 rounded-2xl bg-blue-400 px-4 py-3 text-sm text-white">
          Beta
        </div>
      )} */}

        <img src={illustrationSrc} alt="task logo" className="hidden sm:block" />
        <div className={cx('py-6 pl-4 pr-8 sm:pt-6', { 'pt-12': price && !freeIcp })}>
          <h2 className="font-semibold">{title}</h2>

          <p className="mb-6 max-w-md">{description}</p>

          <Button
            variant="outlined"
            size="medium"
            onClick={(e) => {
              e.stopPropagation()
              handleCardClick()
            }}
          >
            {buttonLabel} <IconArrowRightSm className="ml-2" />
          </Button>
        </div>
      </div>
    </>
  )
}

export default CreateTaskCard
